import React from 'react'
import VipLayout from '../../../components/vip/VipLayout'

const IntellectualPropertyPage: React.FC = () => {
  return (
    <VipLayout>
      <main>
        <section className="hero">
          <div className="container">
            <span className="kicker">Intellectual Property</span>
            <h1>知识产权咨询</h1>
            <p>围绕商标、专利、著作权等知识产权事项，提供申请前判断、路径建议、材料梳理和布局建议服务。</p>
            <div className="anchor-nav">
              <a href="#trademark">商标</a>
              <a href="#patent">专利</a>
              <a href="#copyright">著作权</a>
            </div>
          </div>
        </section>
        <section className="section" id="trademark">
          <div className="container two-col">
            <div>
              <h2 className="section-title">商标咨询</h2>
              <p className="section-desc">适用于品牌命名、产品线布局、企业名称保护与经营品牌化场景。</p>
            </div>
            <div className="card content-card">
              <ul className="list">
                <li>申请类别与布局建议</li>
                <li>近似风险初步判断</li>
                <li>申请材料清单与流程辅导</li>
                <li>商标代理备案边界说明</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="section" id="patent">
          <div className="container two-col">
            <div className="card content-card">
              <ul className="list">
                <li>专利类型与申请路径建议</li>
                <li>专利申请前资料梳理建议</li>
                <li>专利代理机构合作边界说明</li>
                <li>技术成果转知识产权思路建议</li>
              </ul>
            </div>
            <div>
              <h2 className="section-title">专利咨询</h2>
              <p className="section-desc">适用于技术研发、系统方案、软件架构与产品创新成果的知识产权保护思路咨询。</p>
            </div>
          </div>
        </section>
        <section className="section" id="copyright">
          <div className="container">
            <h2 className="section-title">著作权咨询</h2>
            <div className="grid cols-3" style={{marginTop: '24px'}}>
              <div className="card content-card">
                <h3>软件著作权</h3>
                <p className="lead" style={{fontSize: '15px'}}>适用于网站、平台、SaaS、AI 产品系统等软件成果。</p>
              </div>
              <div className="card content-card">
                <h3>作品著作权</h3>
                <p className="lead" style={{fontSize: '15px'}}>适用于文字、美术、视频、宣传内容等成果归属与登记咨询。</p>
              </div>
              <div className="card content-card">
                <h3>组合布局建议</h3>
                <p className="lead" style={{fontSize: '15px'}}>围绕品牌、代码、内容、算法成果建立更完整的知识产权保护思路。</p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </VipLayout>
  )
}

export default IntellectualPropertyPage
